/**
 * Controller: RolesCreateModal
 */
angular.module('acme.view.application.roles.createModal.controllers', [])
.controller('RolesCreateModalController', [ '$scope', '$uibModalInstance', 'roles', function ($scope, $uibModalInstance, roles) {

    $scope.errors = [];

    $scope.model = {
      name: '',
      active: true
    };

    $scope.init = function() {

    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.trim = function(s) {
      return s.replace(/\s+/g, '').toLowerCase();
    };

    $scope.toggleActive = function() {
      $scope.model.active = !$scope.model.active;
    };

    $scope.isUnique = function() {
      var i, ii,
        trimmed,
        trimmedCurrent = $scope.trim($scope.model.name),
        r = true;

      for (i=0,ii=roles.length;i<ii;i++) {
        trimmed = $scope.trim(roles[i].name);
        if (trimmedCurrent === trimmed) {
          r = false;
          break;
        }
      }

      return r;

    };

    $scope.done = function() {
      if ($scope.isUnique()) {
        if ($scope.model.name.replace(/\s+/g, '').length > 0) {
          $scope.success();
        }else{
          $scope.errors.push({ message: 'Please enter a valid role name'});
        }
      }else{
        $scope.errors.push({ message: 'A role with name "' + $scope.model.name + '" already exists' });
      }
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close($scope.model);
    };

    $scope.init();

}]);